import ManualModal from './ManualModal';

export default ManualModal;
